import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import themeLib from '@vr/lib/styles/theme';
import { Checkbox } from '~/elements';
import AgreementLinks from '~/compositions/TermsAndPolicy/AgreementLinks';
import { Content, Title, Text, Consent, Actions, Button } from './commonStyles';
import { VRPAT } from '~/config/constants';

type TAttention = {
  shouldAccept: boolean;
  onAccept: () => void;
  onReminder: () => void;
};

export default function Accept({
  shouldAccept,
  onAccept,
  onReminder,
}: TAttention): JSX.Element {
  const [checked, setChecked] = useState(false);
  // @ts-ignore
  const issuer = useSelector(state => state?.issuer?.name);
  const checkColor =
    issuer === VRPAT ? themeLib.colors.institucional : '#195C9D';

  const checkboxColor = checked ? checkColor : themeLib.colors.gray400;

  const btnStyle = issuer === VRPAT ? 'institutional' : 'caixa';

  return (
    <Content>
      <Title>Atenção</Title>
      <Text>
        Nossos Termos de Uso e Política de Privacidade foram atualizados.
      </Text>
      <Consent>
        {/* @ts-ignore */}
        <Checkbox
          ariaLabel="Checkbox para aceitar os termos"
          onChange={(e: { target: { checked: boolean } }) =>
            setChecked(e.target.checked)
          }
          checked={checked}
          containerProps={{
            style: {
              color: themeLib.colors.gray400,
            },
          }}
          checkboxProps={{
            style: {
              color: checkboxColor,
            },
          }}
          label={<AgreementLinks />}
        />
        <Actions shouldAccept={shouldAccept}>
          {/* @ts-ignore */}
          <Button
            disabled={!checked}
            fullWidth
            ariaLabel="Enviar termo de aceite"
            label="Enviar"
            variant="contained"
            onClick={() => onAccept()}
            color={btnStyle}
          />
          {/* @ts-ignore */}
          {!shouldAccept && (
            <Button
              fullWidth
              ariaLabel="Lembre-me depois sobre o termo de aceite"
              label="Lembre-me depois"
              variant="contained"
              onClick={() => onReminder()}
              color={btnStyle}
            />
          )}
        </Actions>
      </Consent>
    </Content>
  );
}
